import type { FC } from 'react'
import type { SceneProps } from '@/components/landing/games/scene-ui'

import GaltonBoard from '@/components/landing/galton-board'
import { PLINKO_8 } from '@/constants/kinematic'

const PlinkoScene: FC<SceneProps> = ({ active }) => {
    return (
        <div className='absolute inset-0 px-3 pb-3 pt-12'>
            <GaltonBoard
                rows={8}
                multipliers={PLINKO_8}
                interval={560}
                playing={active}
                compact
                label='Plinko board with eight rows of pegs'
                className='size-full cursor-pointer'
            />
        </div>
    )
}

export default PlinkoScene
